<script lang="ts" setup>
import { computed, ComputedRef } from 'vue';
import { UserModel, LevelModel, RoleModel } from '@/types';
import { useAuthStore } from '@/stores';

const authStore = useAuthStore();
const user: ComputedRef<UserModel | undefined> = computed(() => authStore.userModel);

const userLevels = computed(() =>
    authStore.userLevels.map((level: LevelModel) => level.id + ':' + level.name),
);
const userRoles = computed(() =>
    authStore.userRoles.map((role: RoleModel) => role.id + ':' + role.name),
);
const userPermissions = computed(() => authStore.userPermissions);
</script>

<template>
    <div class="p-4" v-if="user !== undefined">
        <h3>ProfilePage</h3>
        <p>id: {{ user.id }}</p>
        <p>name: {{ user.name }}</p>
        <p>email: {{ user.email }}</p>
        <p>levels: {{ userLevels }}</p>
        <p>roles: {{ userRoles }}</p>
        <p>permissions: {{ userPermissions }}</p>
    </div>
</template>
